import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  sessionOptions: { refetchInterval: 0, refetchOnWindowFocus: true, refetchWhenOffline: false },
});

export const { useSession, signIn, signOut, refreshToken } = authClient;
